import { useEffect, useState } from "react";
import clienteAxios from "../../../configAxios/configAxios";

export const useCategoriasRepuestos = () => {
  const [categorias, setCateorias] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        let response = await clienteAxios.get("repuesto/categorias");

        setLoading(false);

        if (response.status === 200) {
          let data = response.data.data;
          setCateorias(data);
          return;
        }

        setError(true);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchCategorias();
  }, []);

  return { categorias, loading, error };
};

export const useRepuestoSlug = (slug, modulo) => {
  const [repuesto, setRepuesto] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRepuesto = async () => {
      try {
        let response = await clienteAxios.get(
          `Repuesto/slug/${modulo}/${slug}`
        );

        if (response.status === 200) {
          let data = response.data.data;

          setRepuesto(data);
          setLoading(false);
          return;
        }
        setLoading(false);
        setError(true);
      } catch (error) {
        setLoading(false);
        setError(true);
      }
    };

    if (slug && modulo) {
      fetchRepuesto();
    }
  }, [slug, modulo]);

  return { repuesto, loading, error };
};


export const useModelosRepuesto = (idRepuesto) =>{
  const [modelos,setModelos] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRepuesto = async () => {
      try {
        let response = await clienteAxios.get(
          `Repuesto/Vehiculos/${idRepuesto}`
        );

        if (response.status === 200) {
          let data = response.data.data;

          setModelos(data);
          setLoading(false);
          return;
        }
        setLoading(false);
        setError(true);
      } catch (error) {
        setLoading(false);
        setError(true);
      }
    };

    if (idRepuesto) {
      fetchRepuesto();
    }
  }, [idRepuesto]);

  return { modelos, loading, error };
}